import { render } from "./sublime-saturdays.vue?vue&type=template&id=0288f612&scoped=true"
import script from "./sublime-saturdays.vue?vue&type=script&lang=js"
export * from "./sublime-saturdays.vue?vue&type=script&lang=js"

import "./sublime-saturdays.vue?vue&type=style&index=0&id=0288f612&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0288f612"]])

export default __exports__